export default "__VITE_ASSET__Dj34AwZ8__"